export function tokensToStyle(style) {
    if (!style) {
        return undefined;
    }
    return processTokensToStyle(style.normal, style.font);
}
export function tokensToSelectedStyle(style) {
    if (!style) {
        return undefined;
    }
    return processTokensToStyle(style.selected, style.font);
}
function processTokensToStyle(colors, font) {
    const css = {};
    if (colors && colors.bg) {
        css.backgroundColor = colors.bg;
    }
    if (colors && colors.fg) {
        css.color = colors.fg;
    }
    return Object.assign(Object.assign({}, font), css);
}
